import React from 'react';
import './AjaxComponents.css';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes';
import clsx from 'clsx';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles } from '@material-ui/core/styles';
import TableIconWarning from '../../images/table_icon_warning.svg';
import TableIconError from '../../images/table_icon_error.svg';
import { format } from 'date-fns';
import Immutable from 'seamless-immutable';

const useStyles = makeStyles((theme) => {
  return {
    DetailsWidget: {
      display: 'flex',
      flexDirection: 'column',
      overflowWrap: 'break-word',
    },
    cellPadding: {
      paddingLeft: 10,
      padding: '11px 20px',
      fontSize: 16,
    },
    noClick: {
      cursor: 'text',
    },
    noDataCell: {
      padding: '10px 20px',
    },
    noSortLabel: {
      color: Colors.lightGrey,
      padding: '11px 20px',
      textTransform: 'capitalize',
    },
  };
});

const LogsTable = (props) => {
  const cellPadding = true;
  const { t } = useTranslation();
  const noDataText = t('ajax.noLogs');
  const classes = useStyles();
  const { logs } = props;
  const data1 = logs.map(({ timestamp, eventCode, hubName, sourceObjectName, sourceRoomName }) => ({
    timestamp,
    time: format(new Date(timestamp), 'd.M.yyyy HH:mm:ss'),
    hubName: hubName,
    event: t(`ajax.${eventCode}`, { hubName, sourceObjectName, sourceRoomName }),
  }));
  const data = Immutable.asMutable(data1).sort((a, b) => b.timestamp - a.timestamp);
  const columns = [
    { title: t('ajax.time'), field: 'time' },
    { title: t('ajax.hubName'), field: 'hubName' },
    { title: t('ajax.event'), field: 'event' },
  ];

  return (
    <Table>
      <TableHead>
        <TableRow>
          {columns.map((column) => {
            return (
              <TableCell key={column.field}>
                <div className={classes.noSortLabel}>{column.title}</div>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {typeof data !== 'undefined' && data && data.length > 0 ? (
          data.map((row, index) => {
            const isWarningRow = props.colorRowField && row[props.colorRowField].includes(props.warningCondition);
            const isErrorRow = props.colorRowField && row[props.colorRowField].includes(props.errorCondition);

            return (
              <TableRow key={index} className={classes.noClick}>
                {props.hasWarningsOrErrors && (
                  <TableCell
                    className={clsx(isWarningRow && classes.warningCell, isErrorRow && classes.errorCell)}
                    key={'warningErrorCellStart' + index}
                  >
                    {isWarningRow && <img src={TableIconWarning} alt="warning" className={classes.warningErrorIcon} />}
                    {isErrorRow && <img src={TableIconError} alt="error" className={classes.warningErrorIcon} />}
                  </TableCell>
                )}

                {columns.map((column) => {
                  return (
                    <TableCell key={column.field + index} className={clsx(cellPadding && classes.cellPadding)}>
                      {row[column.field]}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })
        ) : (
          <TableRow>
            <TableCell className={classes.noDataCell} colSpan={columns.length}>
              {noDataText}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default LogsTable;
